module.exports = __webpack_public_path__ + "static/portfolio5-3c1b1c31dad9afdb6efd4ef7e4ea0be5.png";